import { useQuery } from '@apollo/client';
import { Container, VisuallyHidden } from '@unmind/design-system';
import { LINE_MANAGERS_CATEGORY } from 'Managers/constants';
import React from 'react';
import { useTranslation } from 'react-i18next';
import SectionError from 'Shared/SectionError';
import LoadingIndicator from 'Shared/LoadingIndicator';
import { useUserEntitlements } from 'hooks/useUserEntitlements';
import Route404 from 'App/Router/Route404';
import { MANAGER_CONTENT_QUERY } from './graphql/manager-content';
import {
  managerContent,
  managerContentVariables,
} from './graphql/__generated__/managerContent';
import { ManagersCategorySection } from './components';

import './ManagersPage.scss';

const ManagersPage = () => {
  const { t } = useTranslation('managers');
  const { entitlements, loading: isUserEntitlementsLoading } =
    useUserEntitlements();

  const { data, loading, error, refetch } = useQuery<
    managerContent,
    managerContentVariables
  >(MANAGER_CONTENT_QUERY, {
    fetchPolicy: 'cache-and-network',
    errorPolicy: 'all',
    returnPartialData: true,
    variables: { slug: LINE_MANAGERS_CATEGORY },
    skip: !entitlements?.lineManagerContent,
  });

  if (loading || isUserEntitlementsLoading) {
    return <LoadingIndicator />;
  }

  if (!entitlements?.lineManagerContent) {
    return <Route404 />;
  }

  if (error) {
    return (
      <main className="managers-page">
        <SectionError
          onRetry={async () => refetch({ slug: LINE_MANAGERS_CATEGORY })}
        />
      </main>
    );
  }

  return (
    <Container className="managers-page">
      <VisuallyHidden element="h1">{t('title')}</VisuallyHidden>
      <div className="container">
        {data?.exploreCategory?.subCategories?.map(category =>
          category ? (
            <ManagersCategorySection
              key={category.slug}
              category={category}
              assetToken={data.getAssetToken?.assetToken ?? null}
            />
          ) : null,
        )}
      </div>
    </Container>
  );
};

export default ManagersPage;
